import { render, staticRenderFns } from "./IconFullscreen.vue?vue&type=template&id=467a0059&scoped=true&"
import script from "./IconFullscreen.vue?vue&type=script&lang=js&"
export * from "./IconFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a0059",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467a0059')) {
      api.createRecord('467a0059', component.options)
    } else {
      api.reload('467a0059', component.options)
    }
    module.hot.accept("./IconFullscreen.vue?vue&type=template&id=467a0059&scoped=true&", function () {
      api.rerender('467a0059', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconFullscreen.vue"
export default component.exports